import { useSidebarFloats } from './use-sidebar-floats';

export const useSplitViewViewportAvailable = () => !useSidebarFloats();
